import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";

// observable store
const consignmentFilterStore = makeObservable({});
const useConsignmentFilters = () => {
  const formik = useFormik({
    initialValues: {
      limit: 50,
      offset: 0,
      sort1: { operator: "ASC" },
      sort2: { operator: "ASC" },
      sort3: { operator: "ASC" },
      tab: "artworks",
      _contact: { typeId: { operator: "in" } },
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    consignmentFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { consignmentFilterStore, useConsignmentFilters };
